/*export function getJssdkSign(data) {
  return request.post("http:127.0.0.1:8091/projectName/getJssdkSign", data);
}*/
import wx from 'weixin-js-sdk'
import fa from "element-ui/src/locale/lang/fa";
//微信扫一扫调用sdk核心配置
let url = location.href.split("#")[0]; //这里【url参数一定是去参的动态的当前页网址】
let params = {};
params.url = url;
console.log("获取当前的url", url)
export default {
    getJssdkSign(res) {
        console.log('...', res)
            //console.log("微信返回接口成功",res)
            //console.log(this.$wx)
        wx.config({
            // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            debug: false,
            // 必填，公众号的唯一标识
            appId: res.data.appId,
            // 必填，生成签名的时间戳
            timestamp: res.data.timestamp,
            // 必填，生成签名的随机串
            nonceStr: res.data.nonceStr,
            // 必填，签名
            signature: res.data.signature,
            // 必填，需要使用的JS接口列表，所有JS接口列表
            jsApiList: res.data.jsApiList
        });

        setTimeout(() => {
            wx.ready(function() {
                console.log("验证完成预调方法")
                wx.onMenuShareAppMessage({
                    title: 'test', // 分享标题
                    desc: 'test', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: '', // 分享图标
                    success: function() {
                        console.log("分享成功了35468")
                    }
                });

                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            });
        }, 300)


        wx.checkJsApi({
            jsApiList: ['chooseImage', 'updateAppMessageShareData'], // 需要检测的JS接口列表
            success: function(res) {
                // 以键值对的形式返回，可用的api值true，不可用为false
                // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            },
            fail: function(err) {
                console.log("接口检查结果", res)
            }
        });
        wx.error(function(res) {
            console.log("微信公众号签名验证失败111", res)
        });
    },

    choosePic(that, picUrl, serverId) {
        wx.chooseImage({ //
            count: 1, // 默认9
            sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: function(res) {
                console.log("图片选择成功", res)
                let localId = res.localIds; //获取到本地localIds
                wx.getLocalImgData({
                    localId: localId[0],
                    success: function(res) {
                        let localData = res.localData; // localData是图片的base64数据，可以用img标签显示
                        let imageBase64 = '';
                        if (localData.indexOf('data:image') == 0) {
                            imageBase64 = localData;
                        } else {
                            imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
                        }
                        that.registeInfo3[picUrl] = imageBase64
                        wx.uploadImage({ //上传到微信服务器
                            localId: localId.toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
                            isShowProgressTips: 1, // 默认为1，显示进度提示
                            success: function(ret) {
                                that.registeInfo2[serverId] = ret.serverId
                            },
                            error: function(ret) {
                                console.log('选取图片报错', ret);
                            }
                        });
                    }
                });
            },
            error: function(res) {
                console.log("图片选择失败", res)
            }
        });
    },

    shareShopBoss(that) {
        console.log("分享接口")
        let share1 = {
            "imgUrl": url, //分享图，默认当相对路 径处理，所以使用绝对路径的的话，“http://”协议前缀必须在。
            "desc": "test", //摘要,如果分享到朋友圈的话，不显示摘要。
            "title": "test", //分享卡片标题
            "link": url, //分享出去后的链接，这里可以将链接设置为另一个页面。
            "success": function() { //分享成功后的回调函数
            },
            'cancel': function() {}
        }
        wx.updateAppMessageShareData(share1);
    },
}

export const $defalutIcon = 'data:image/png;base64,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'

/**
 * 选择图片 todo 能否不返回base64,直接返回id
 * @param that
 */
/*export const choosePic = (that,picUrl,serverId) => {
  wx.chooseImage({//
    count: 1, // 默认9
    sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
    sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
    success: function (res) {
      console.log("图片选择成功", res)
      let localId = res.localIds;//获取到本地localIds
      wx.getLocalImgData({
        localId: localId[0],
        success: function (res) {
          let localData = res.localData; // localData是图片的base64数据，可以用img标签显示
          let imageBase64 = '';
          if (localData.indexOf('data:image') == 0) {
            imageBase64 = localData;
          } else {
            imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
          }
          that.registeInfo3[picUrl] = imageBase64
          wx.uploadImage({//上传到微信服务器
            localId: localId.toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function (ret) {
              that.registeInfo2[serverId] = ret.serverId
            },
            error: function (ret) {
            }
          });
        }
      });
    }
  });
}*/

/*export const shareShopBoss = (that) => {
  wx.onMenuShareAppMessage({
    title: '【佰药汇】通知', // 分享标题
    desc: '恭喜您,您的门店已完成佰药汇平台入驻,资料审核中,请持续关注噢', // 分享描述
    link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: '', // 分享图标
    type: '', // 分享类型,music、video或link，不填默认为link
    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    success: function () {
      console.log("用户分享完成")
      that.handleShareSubmit()
    }
  });
}*/



// WEBPACK FOOTER //
// ./src/commons/wechat.js